(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('attachmentService', attachmentService);

    attachmentService.$inject = ['dataservice', 'common'];
    /* @ngInject */
    function attachmentService(dataservice, common) {
        var service = {
            upload: upload,
            remove: remove
        };

        return service;

        function remove(attachmentIds) {
            for (var i = 0; i < attachmentIds.length; i++) {
                dataservice.deleteItem('api/Attachments/' + attachmentIds[i], true).then(function (response) {

                }, function(error) {console.log(error)});
            }
            
        }

 

        function upload(parentType, parentId, item, elementId) {
            return new Promise(function(resolve) {
                var elmId = elementId || "photo";
                var imgInput = document.getElementById(elmId);
                if (imgInput) {
                    var imgs = [];
                    for (var i = 0; i < imgInput.files.length; i++) {
                        imgs.push(imgInput.files[i]);
                    }
                    var promises = [];
                    while (imgs.length > 0) {
                        var img = imgs.pop();
                        promises.push(process(img, parentType, parentId, item));
                    }
 
                    resolve(common.$q.all(promises).then(function () {
                        
                    }))
                  

                    
                    if (!imgs.length) {
                        $(imgInput).val("");
                        resolve(item);
                        return;
                    }
                }
                return common.$q.when("nothingToUpload");
            })
        }

        function process(img, parentType, parentId, item) {
            return new Promise(function(resolve, reject)  {

                if (img.type.match(/image.*/)) {
                    var maxSize = 640;
                    var quality = 0.7;
                    var image = new Image();
                    var canvas = document.createElement('canvas');
                    var blobUrl = URL.createObjectURL(img);
                    image.src = blobUrl;
                    image.onerror = function () {
                        URL.revokeObjectURL(this.src);
                        console.log("Couldn't load image");
                    }
                    image.onload = function () {
                        URL.revokeObjectURL(this.src);
                        var width = this.width;
                        var height = this.height;
                        if (width > height) {
                            if (width > maxSize) {
                                height = Math.round((height * maxSize) / width);
                                width = maxSize;
                            }
                        } else {
                            if (height > maxSize) {
                                width = Math.round((width * maxSize) / height);
                                height = maxSize;
                            }
                        }

                        canvas.width = width;
                        canvas.height = height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(image, 0, 0, width, height);
                        canvas.toBlob(function (b) {
                            resolve(uploadPromise(parentType, parentId, b, null, img.name, item))
                        }, img.type, quality);
                    }
                }
                else {
                    resolve(uploadPromise(parentType, parentId, img, null, item));

                }
            }
            )
            

        }

        function uploadPromise(parentType, parentId, bytes, dto, imgName, item) {
            return dataservice.postFile('api/Attachments/PostFile/' + parentType + '/' + parentId, bytes, dto, imgName)
                .then(function (uploadResult) {
                    if (item) {

                        item.FileName = uploadResult.data.FileName;
                        item.Base64Data = uploadResult.data.Base64Data;
                        item.StoredFile = uploadResult.data.StoredFile;
                        item.HasAttachment = true;
                        item.AttachmentId = uploadResult.data.ID;
                    }
                }, function (error) { })
}

           
        
    }
})();
